<script>
  import { layoutMethods, eloadB2BMethods } from "@/state/helpers";
  import vue2Dropzone from "vue2-dropzone";
  import "vue2-dropzone/dist/vue2Dropzone.min.css";
  import shortid from "shortid";
  import Swal from "sweetalert2";

  /**
   * Eload b2b action component
   */
  export default {
    props:{
        view: String,
        requestData: Object,
        userAccess: Object
    },
    page: {
      title: "eLoad B2B Action"
    },
    components: {
        vueDropzone: vue2Dropzone,
    },
    computed: {
    },
    data() {
      return {
        title: "eLoad B2B Action",
        rejectForm:{
            confirm: false,
            reason:null,
            remarks:null
        },
        reasonOptions:[
            {text: 'Select Reason', value: null, $disabled: true},
            {text: 'Incomplete or Incorrect Documentation', value: 'Incomplete or Incorrect Documentation'},
            {text: 'Banking Relationship Issues', value: 'Banking Relationship Issues'},
            {text: 'Risk of Fraud or Suspicious Activity', value: 'Risk of Fraud or Suspicious Activity'},
            {text: 'Others', value: 'Others'}
        ],
        dropzoneOptions: {
            url: '/',//'https://httpbin.org/post', //
            maxFiles: 1,                  // Allow only one file to be uploaded
            maxFilesize:10,
            acceptedFiles: 'image/*',     // Only accept image files
            dictDefaultMessage: 'Drop an image here or click to upload.',
            dictMaxFilesExceeded: 'You can only upload one image.',
            dictInvalidFileType: 'Only images are allowed.',
            thumbnailWidth: 150,          // Thumbnail width (optional)
            thumbnailHeight: 150,         // Thumbnail height (optional)
            addRemoveLinks: true,        // Enable remove button
            // autoProcessQueue: false,
        },
        proofOfConfirmationImg: {
            confirm: false,
            filename: null,
            type: null,
            base64: null,
        },
        s3key: null,
        isUploadingImg: false,
        uploadErrorMessage: null,
      };
    },
    methods: {
        ...layoutMethods,
        ...eloadB2BMethods,
        openModal(modal=''){
            this.rejectForm = {
                confirm: false,
                reason:null,
                remarks:null
            }
            this.$bvModal.show(modal+this.requestData.id);
        },
        closeModal(modal=''){
            this.$bvModal.hide(modal+this.requestData.id);
        },
        async submitReject(){
            // console.log(">> rejectFrom",JSON.stringify(this.rejectForm))
            // //axios the api
            await this.postRejectedRequest({
                ...this.rejectForm,
                id: this.requestData.id,
                reference_number: this.requestData.reference_number,
            })
            .then((res)=>{
                console.log("Done Approving",res);
                Swal.fire("Successfully Rejected!", `The fund request has been successfully rejected.`, "success");
                this.closeModal("bv-modal-reject");
                this.reload();
            })
            .catch((err)=>{
                console.log("Error while rejecting:",err);
                Swal.fire("Failed!", err?.message?.description??`Unable to reject the request please try again later`, "error");
            });
        },
        async submitApproved(){
            if(!this.proofOfConfirmationImg.confirm){
                return Swal.fire("Failed!", `Unable to upload proof of confirmation`, "error");
            }
            this.isUploadingImg = true;
            // console.log(">> proofOfConfirmationImg",JSON.stringify(this.proofOfConfirmationImg))
            //axios the api
            if(await this.uploadProof()){
                this.isUploadingImg = false;
                await this.postApprovedRequest({
                    proofKey:this.s3key,
                    ...this.requestData
                })
                .then((res)=>{
                    console.log("Done Approving",res);
                    Swal.fire("Successfully Approved!", `The fund request has been successfully approved.`, "success");
                    this.closeModal("bv-modal-approve");
                    this.reload();
                })
                .catch((err)=>{
                    console.log("Error while approving:",err);
                    Swal.fire("Failed!", `Unable to approve the request please try again later`, "error");
                });
            }
        },
        getValidationState({ dirty, validated, valid = null }) {
            return dirty || validated ? valid : null;
        },
        handleSending(file){
            // console.log('File:', file);
            // console.log('xhr:', xhr);
            // console.log('formData:', formData);
            // console.log('generateShortId()', this.generateShortId());
            // console.log('file.dataURL', file.dataURL);
            // console.log('file.type.split("/")[1]', file.type.split("/")[1]);
            // console.log('buffer', new Buffer.from(file.dataURL.replace(/^data:image\/[a-zA-Z+]+;base64,/, ""), "base64"));
            // console.log('buffer', file[0]);
            
            this.proofOfConfirmationImg.filename    = `${this.generateShortId()}.${file.type.split("/")[1]}`
            this.proofOfConfirmationImg.type        = file.type.split("/")[1]

            const reader = new FileReader();
            reader.onloadend = () => {
                const base64Data = reader.result;
                // console.log(">>> base64Data:",base64Data);
                this.proofOfConfirmationImg.base64 = new Buffer.from(base64Data.replace(/^data:image\/[a-zA-Z+]+;base64,/, ""), "base64");
                this.proofOfConfirmationImg.confirm=true
                this.uploadErrorMessage = null
            };
            reader.readAsDataURL(file);
        },
        handleFileAdded(file) {
            // This method will be called when a file is added to the dropzone
            console.log('File added:', file);
            // If you want to automatically remove the previous file when a new file is added
            if (this.$refs.myDropzone.files.length > 1) {
                this.$refs.myDropzone.removeFile(this.$refs.myDropzone.files[0]);
            }
        },
        handleSuccess(file, response) {
            // Handle successful upload (if needed)
            console.log('File uploaded successfully:', file);
            console.log('Response:::', response);
            // console.log('generateShortId()', this.generateShortId());
            // console.log('file.dataURL', file.dataURL);
            // console.log('file.type.split("/")[1]', file.type.split("/")[1]);
            // console.log('buffer', new Buffer.from(file.dataURL.replace(/^data:image\/[a-zA-Z+]+;base64,/, ""), "base64"));
            
            this.proofOfConfirmationImg = {
                confirm: true,
                filename: `${this.generateShortId()}.${file.type.split("/")[1]}`,
                type: file.type.split("/")[1],
                base64: new Buffer.from(file.dataURL.replace(/^data:image\/[a-zA-Z+]+;base64,/, ""), "base64"),
            };
            // console.log('proofOfConfirmationImg:', this.proofOfConfirmationImg);

        },
        generateShortId(){
            return shortid.generate();
        },
        async uploadProof() {
            let isUploaded = false;
            if (this.proofOfConfirmationImg.base64) {
                var proofOfConfirmationImg = { ...this.proofOfConfirmationImg,subFolder:"proof" };

                await this.uploadEloadB2BDepositImg(proofOfConfirmationImg)
                .then((imageKey) => {
                    this.s3key = imageKey;
                    isUploaded = true;
                })
                .catch((err) => {
                    Swal.fire("Upload Failed!", `${err}`, "error");
                });
            } 

            return isUploaded;
        },
        async reload(){
            this.$emit('reload', this.requestData)
        },
        onFileError(file, errorMessage) {
            const dropzone = this.$refs.myDropzone.dropzone;
            console.log("Error on file:", errorMessage,dropzone.files.length);
            file.previewElement.querySelector('.dz-error-message').style.display = 'none';

            if(
                errorMessage.includes("only upload one") ||
                errorMessage.includes("Only images") ||
                errorMessage.includes("File is too big")
            ){
                this.proofOfConfirmationImg.confirm = false
                this.uploadErrorMessage = errorMessage
            }
            else if(dropzone.files.length>1){
                this.proofOfConfirmationImg.confirm = false
                this.uploadErrorMessage = "You can only upload one image."
            }
            // if(errorMessage.includes("DOCTYPE")){
            //     file.previewElement.querySelector('.dz-error-message').style.display = 'none';
            // }
        },
        onFileRemoved(file) {
            // Handle file removal if needed
            console.log('File removed:', file);
        }
    },
    async mounted(){
        // console.log(">>>>",this.generateShortId())
    }
  }
    
</script>
<style scoped>
    .custom-green{
        background: #508F30;
    }
    .custom-red{
        background: #BC3D40;
    }
    .fs-100{
        font-size: 100px;
    }
    ul {list-style-type: none;} 
    .form-check-input:checked {
        background-color: #BC3D40;
        border-color: #BC3D40;
    }
    .loading-container {
        position: fixed;  /* Fixed position to cover the entire viewport */
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-color: #f3f3f3ca; /* Semi-transparent background */
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 99999; /* Make sure it appears on top */
    }

    .loading-spinner {
        border: 8px solid #f3f3f3; /* Light grey background for spinner */
        border-top: 8px solid #7F4697; /* Blue color for the spinner */
        border-radius: 50%;
        width: 50px;
        height: 50px;
        animation: spin 2s linear infinite;
    }

    /* Spinner animation */
    @keyframes spin {
        0% { transform: rotate(0deg); }
        100% { transform: rotate(360deg); }
    }

    .cw-110{
        width: 110px;
    }
</style>
<template>
  <div><!-- outer div-->
      <div v-if="requestData.status == 'requesting' && userAccess.update">
        <div v-if="view=='list'">
            <b-button variant="success" class="p-1 me-2 custom-green" @click="openModal('bv-modal-approve')">
                <i class="bx bx-check-circle bx-xs bx-fw"></i>
            </b-button>

            <b-button variant="danger" class="p-1 custom-red" @click="openModal('bv-modal-reject')"
                ><i class="bx bx-x-circle bx-xs bx-fw"></i>
            </b-button>
        </div>
        <div v-else>
            <b-button variant="success" class="p-1 me-2 custom-green cw-110" @click="openModal('bv-modal-approve')">
                <i class="bx bx-check-circle bx-xs bx-fw"></i>
                Approve
            </b-button>

            <b-button variant="danger" class="p-1 custom-red cw-110" @click="openModal('bv-modal-reject')"
                ><i class="bx bx-x-circle bx-xs bx-fw"></i>
                Reject
            </b-button>
        </div>
      </div><!-- end of row-->

    <b-modal :id="`bv-modal-reject${requestData.id}`"
      centered
      hide-header
      hide-footer
      hide-header-close
    no-close-on-esc
    no-close-on-backdrop
    >
        <div class="row text-center">
            <h1 class="col-12"><i class="bx bx-info-circle text-info fs-100"></i></h1>
            <h2 class="col-12">Reject Fund Request</h2>
            <p>Are you sure you want to reject this fund request? This action cannot be undone.</p>
            <ul>
                <li>
                    <span class="fw-semibold">Merchant Name:</span> {{ requestData?.name??requestData?.merchantName??null | notEmpty }}
                </li>
                <li>
                    <span class="fw-semibold">Payment Reference Number:</span> {{ requestData.reference_number }}
                </li>
                <li>
                    <span class="fw-semibold">Amount Paid:</span> PHP {{ requestData.paid_amount | numberWithCommas }}
                </li>
            </ul>
        </div>

        <ValidationObserver v-slot="{ handleSubmit, reset }">
            <b-form @submit.prevent="handleSubmit(submitReject)" @reset.prevent="reset">
                <div class="form-group mb-3">
                    <div class="form-check mt-3 d-flex justify-content-center">
                        <input type="checkbox" id="formrow-customCheck" class="form-check-input me-3" v-model="rejectForm.confirm" style="border-color:#BC3E40;">
                        <label for="formrow-customCheck" class="form-check-label">Please confirm that you want to reject the request. </label>
                    </div>
                </div>

                <b-col sm="12" class="mb-3" v-if="rejectForm.confirm"><!--Reason-->
                    <validation-provider name="Reason" rules="required" v-slot="validationContext">
                        <b-form-group>
                            <b-form-select class="form-select rounded-0 rounded-start rounded-end shadow-none custom-select w-100" style="width:160px"
                                id="change-type"
                                v-model="rejectForm.reason"
                                :options="reasonOptions"
                                :state="getValidationState(validationContext)"
                            ></b-form-select>
                        </b-form-group>
                        <b-form-invalid-feedback>
                            {{ validationContext.errors[0] }}
                        </b-form-invalid-feedback>
                    </validation-provider>
                </b-col><!--Reason-->

                <b-col sm="12" class="mb-3 text-left" v-if="rejectForm.reason == 'Others' && rejectForm.confirm"><!--Reason-->
                    <validation-provider name="Remarks" rules="required" v-slot="validationContext">
                        <div>
                            <span class="text-muted float-end">{{rejectForm.remarks == null ? 0 : rejectForm.remarks.length}}/100 characters limit</span>
                            <label>Remarks <span class="text-danger">*</span></label>
                            <b-form-textarea
                                v-model="rejectForm.remarks"
                                placeholder="Enter your remarks here..."
                                rows="2"
                                max-rows="3"
                                :maxlength="100"
                                :state="getValidationState(validationContext)"
                            ></b-form-textarea>
                            <b-form-invalid-feedback>
                                {{ validationContext.errors[0] }}
                            </b-form-invalid-feedback>
                        </div>
                    </validation-provider>
                </b-col><!--Reason-->

                <div class="text-center">
                    <b-button type="button" variant="primary" class="me-2" @click="closeModal(`bv-modal-reject`)">
                        No, Cancel
                    </b-button>
                    <b-button type="submit" variant="secondary" :disabled="!rejectForm.confirm || (rejectForm.reason == null) || (rejectForm.reason == 'Others' && rejectForm.remarks == null)">
                        Yes, Reject Request 
                        <!-- {{ (rejectForm.reason == null)}} {{ !rejectForm.confirm }} -->
                    </b-button>
                </div>
            </b-form>
        </ValidationObserver>
    </b-modal>

    <b-modal :id="`bv-modal-approve${requestData.id}`"
        centered
        hide-header
        hide-footer
        hide-header-close
        no-close-on-esc
        no-close-on-backdrop
    >   
        <div class="container">
            <div class="loading-container" v-if="isUploadingImg">
                <div class="loading-spinner"></div>
                <p class="loading-text ms-3">Uploading Img...</p>
            </div>
            <div class="row text-center">
                <h1 class="col-12"><i class="bx bx-info-circle text-info fs-100"></i></h1>
                <h2 class="col-12">Proof of Confirmation</h2>
                <p>Please upload the deposit screenshot as <br>proof of confirmation.</p>
            </div>
            <div class="my-3">
                <vue-dropzone
                    id="proofOfConfirmation"
                    ref="myDropzone"
                    :use-custom-slot="true"
                    :options="dropzoneOptions"
                    @vdropzone-success="handleSuccess"
                    @vdropzone-addedfile="handleFileAdded"
                    @vdropzone-sending="handleSending"
                    @vdropzone-error="onFileError"
                    @vdropzone-removedfile="onFileRemoved"
                >
                    <div class="dropzone-custom-content">
                        <i class="display-4 text-primary bx bx-upload"></i>
                        <h4>Drop an image here or click to upload.</h4>
                    </div>
                </vue-dropzone>
                <span class="text-danger fw-semibold" v-if="uploadErrorMessage != null">{{ uploadErrorMessage }}</span>
            </div>
            <div class="text-center">
                <b-button type="button" variant="primary" class="me-2" @click="closeModal(`bv-modal-approve`)">
                    Close
                </b-button>
                <b-button type="submit" variant="secondary" :disabled = "!proofOfConfirmationImg.confirm" @click="submitApproved">
                    Confirm
                    <!-- {{ (rejectForm.reason == null)}} {{ !rejectForm.confirm }} -->
                </b-button>
            </div>
        </div>
    </b-modal>
  </div> <!-- end of outer div-->
</template>
<!-- 
{{ view }}
{{ requestData }} -->